import { useCallback, useEffect, useMemo, useState } from "react";
import { useAuth } from "../lib/auth";
import { useAcoesVisita } from "../lib/acoesVisita";
import { buscarVisitas } from "../lib/visitas";
import { Cabecalho } from "../components/Layout";
import { TabelaVisitas } from "../components/TabelaVisitas";
import { MOTIVOS_NAO_MATRICULA, type Visita } from "../lib/tipos";

/**
 * "Não efetivadas" reúne dois status: quem optou por outra escola e quem
 * cancelou. A API filtra um status por vez, então busco os dois e junto.
 */
export default function NaoEfetivadas() {
  const { podeAoMenos } = useAuth();
  const podeEditar = podeAoMenos("CONSULTOR");
  const [itens, setItens] = useState<Visita[]>([]);
  const [totalGeral, setTotalGeral] = useState(0);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");
  const [motivo, setMotivo] = useState("");

  const carregar = useCallback(async () => {
    setCarregando(true);
    try {
      const [outra, cancelada, todas] = await Promise.all([
        buscarVisitas({ status: "OPTOU_OUTRA_ESCOLA", porPagina: 500 }),
        buscarVisitas({ status: "CANCELADO", porPagina: 500 }),
        buscarVisitas({ porPagina: 1 }),
      ]);
      setItens(
        [...outra.itens, ...cancelada.itens].sort((a, b) => b.inicioEm.localeCompare(a.inicioEm)),
      );
      setTotalGeral(todas.total);
      setErro("");
    } catch (e) {
      setErro(e instanceof Error ? e.message : "Falha ao carregar");
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);
  const acoes = useAcoesVisita(carregar);

  const filtradas = useMemo(
    () =>
      !motivo
        ? itens
        : motivo === "SEM_MOTIVO"
          ? itens.filter((v) => !v.motivoNaoMatricula)
          : itens.filter((v) => v.motivoNaoMatricula === motivo),
    [itens, motivo],
  );

  const taxaPerda = totalGeral ? ((itens.length / totalGeral) * 100).toFixed(1) : "0";

  return (
    <>
      <Cabecalho titulo="Não Efetivadas" />

      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 18, alignItems: "center" }}>
        <select className="campo" style={{ width: 260 }} value={motivo} onChange={(e) => setMotivo(e.target.value)}>
          <option value="">Todos os motivos</option>
          <option value="SEM_MOTIVO">Não informado</option>
          {Object.entries(MOTIVOS_NAO_MATRICULA).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        <div style={{ marginLeft: "auto", padding: "9px 14px", background: "#fef3f2", borderRadius: 8, fontSize: 13, color: "#d92d20", fontWeight: 600 }}>
          {filtradas.length} registro(s) — Taxa de perda: {taxaPerda}%
        </div>
      </div>

      {erro && <div className="erro" style={{ marginBottom: 12 }}>{erro}</div>}

      <TabelaVisitas
        visitas={filtradas}
        carregando={carregando}
        vazio="Nenhuma visita não efetivada"
        colunas={["responsavel", "aluno", "telefone", "curso", "inicio", "status", "motivo"]}
        podeEditar={podeEditar}
        onEditar={acoes.abrirEdicao}
        onFicha={acoes.abrirFicha}
        onExcluir={acoes.excluir}
      />

      {acoes.modais}
    </>
  );
}
